import {get} from "../utils";

export default host => channelId => `${host}/contentCreators/communities/${channelId}/export`
    